export default {
  questionnaire: {
    typeQuestion: {
      20: {
        title: 'Вопрос да/нет'
      },
      40: {
        title: 'Вопрос с уточнением'
      },
      60: {
        title: 'Текстовое поле'
      }
    }
  }
}
